/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import { useQuery } from '@tanstack/react-query';

import HttpServiceSingleton from '../../../services/HttpService/HttpService';
import { ROLES_FILTER_OPTIONS_PATH } from '../../../services/RolesService/constants';
import { API_BASE } from '../../../utils/constants';

interface DashboardFilterOptionsData {
  entitlementValueNames: string[];
  endpointNames: string[];
  entitlementTypes: string[];
}

interface DashboardFilterOptionsResponse {
  success: boolean;
  message: string;
  data: DashboardFilterOptionsData;
}

/**
 * Hook to fetch filter options for dashboard filtering
 * Uses React Query for caching and automatic refetching
 * @returns React Query result with filter options data
 */
// eslint-disable-next-line import/prefer-default-export
export const useDashboardFilters = () =>
  useQuery<DashboardFilterOptionsData>({
    queryKey: ['dashboard-filters'],
    queryFn: async () => {
      const response = (await HttpServiceSingleton.get(
        `${API_BASE}${ROLES_FILTER_OPTIONS_PATH}`,
        { shouldThrowOnError: true }
      )) as DashboardFilterOptionsResponse;

      if (!response.success) {
        throw new Error('Failed to fetch dashboard filter options');
      }

      return response.data;
    },
    retry: 1,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // Keep in cache for 10 minutes after last use (renamed from cacheTime)
  });
